import { createSlice } from '@reduxjs/toolkit'

export const addressSlice = createSlice({
  name: 'address',
  initialState: {
    address: null,
    open: false,
    address1Error: false,
    address2Error: false,
    firstNameError: false,
    lastNameError: false,
    cityError: false,
    zipcodeError: false,
    phoneError: false,
    filled: false,
  },
  reducers: {
    setAddress: (state, action) => {
      state.address = action.payload
    },
    setOpen: (state, action) => {
      state.open = action.payload
    },
    setCountry: (state, action) => {
      state.address.country = action.payload
    },
    setAddress1Error: (state, action) => {
      state.address1Error = action.payload
    },
    setAddress2Error: (state, action) => {
      state.address2Error = action.payload
    },
    setFirstNameError: (state, action) => {
      state.firstNameError = action.payload
    },
    setLastNameError: (state, action) => {
      state.lastNameError = action.payload
    },
    setCityError: (state, action) => {
      state.cityError = action.payload
    },
    setZipcodeError: (state, action) => {
      state.zipcodeError = action.payload
    },
    setPhoneError: (state, action) => {
      state.phoneError = action.payload
    },
    setFilled: (state, action) => {
      state.filled = action.payload
    },
  },
})

export const { setAddress, setOpen, setCountry, setAddress1Error, setAddress2Error, setFirstNameError, setLastNameError, setCityError, setZipcodeError, setPhoneError, setFilled } = addressSlice.actions

export default addressSlice.reducer
